/**
 * Returns true if image rotated 90 or 270 degrees (on it's side)
 */
export const isRotated = (orientation: number): boolean => orientation >= 5;
